module.exports = __webpack_public_path__ + "fonts/71697d23fe5095327a92956f2f977ed7.svg";